export default {
  title: 'Clients guarantee',
  table: {
    client_id: 'Id MB',
    client_name: 'Client Name',
    client_identifier: 'Client identifier',
    available_amount: 'Available amount',
    mb_consumed_amount: 'MB consumed amount',
    diff: 'Remained guarantee amount',
    invoice_amount: 'Invoice not paid amount',
    notification_percent: 'Client notification',
    updated_at: 'Updated at'
  },
  buttons: {
    import: 'Import',
    export: 'Export'
  }
}
